import { Field, NumericInput, TextOutput } from '../../../../Core';
import { ListFieldSection } from '../../../../Layout';
import { IWorksheetComponent } from '../../../Core/types';
import { withInjectedProps, NamePrefixModifier } from '../../../../Core/InjectedPropsContext';

let MeasurementSectionBase = ({ createWorksheetSelector, prefixName }: IWorksheetComponent): JSX.Element => {
  return (
    <NamePrefixModifier appendNamePrefix="Measurement">
      <ListFieldSection>
        <Field input={<NumericInput />} label="Mass of Excavated Wet Soil" name="MassOfExcavatedWetSoil" />
        <Field
          input={<TextOutput />}
          label="Initial Mass of Sand From Calibration"
          name="CalibrationInitialMassOfSand"
        />
        <Field input={<NumericInput />} label="Initial Mass of Sand" name="InitialMassOfSand" />
        <Field input={<NumericInput />} label="Mass of Sand After Pouring" name="MassOfSandAfterPouring" />
        <Field input={<TextOutput />} label="Mass of Sand in Cone" name="MassOfSandInCone" />
        <Field input={<TextOutput />} label="Mass of Sand in Hole" name="MassOfSandInHole" />
        <Field input={<TextOutput />} label="Bulk Density" name="CalculatedBulkDensityOfSand" />
      </ListFieldSection>
    </NamePrefixModifier>
  );
};

const MeasurementSection = withInjectedProps(MeasurementSectionBase);
export { MeasurementSection };
export default MeasurementSection;
